/* eslint max-len: "off" */

export const apiTranslations = {
  positions: {
    Back: {
      en: 'Back of the device',
      fr: "Arrière de l'appareil",
      ar: 'خلف`',
      he: 'אחורי המכשיר',
      ro: 'Spatele dispozitivului',
      nl: 'Achterkant van het apparaat',
      pl: 'Tył urządzenia',
      de: 'Rückseite des Geräts',
      es: 'Parte trasera del dispositivo',
    },
    Front: {
      en: 'Front screen',
      fr: 'Écran avant',
      ar: 'أمام`',
      he: 'המסך הקדמי של המכשיר',
      ro: 'Ecran frontal',
      nl: 'Voorscherm',
      pl: 'Ekran przedni',
      de: 'Vorderseite des Bildschirms',
      es: 'Pantalla frontal',
    },
    Side: {
      en: 'Side of the device',
      fr: "Côté de l'appareil",
      ar: 'الجانب / الحافة',
      he: 'צד המכשיר',
      ro: 'Partea laterală a dispozitivului',
      nl: 'Zijkant van het apparaat',
      pl: 'Bok urządzenia',
      de: 'Seite des Geräts',
      es: 'Lateral del dispositivo',
    },
    BACK: {
      en: 'Back side of the device',
      fr: "Côté arrière de l'appareil",
      ar: 'الجهة الخلفية للجهاز',
      he: 'אחורי המכשיר',
      ro: 'Partea din spate a dispozitivului',
      nl: 'Achterkant van het apparaat',
      pl: 'Tył urządzenia',
      de: 'Rückseite des Geräts',
      es: 'Parte trasera del dispositivo',
    },
    FRONT: {
      en: 'Front screen',
      fr: 'Écran avant',
      ar: 'أمام`',
      he: 'המסך הקדמי',
      ro: 'Ecran frontal',
      nl: 'Voorscherm',
      pl: 'Ekran przedni',
      de: 'Vorderseite des Bildschirms',
      es: 'Pantalla frontal',
    },
    FRONT_BLACK: {
      en: 'Front with black screen',
      fr: 'Avant avec écran noir',
      ar: 'الواجهة الأمامية مع شاشة سوداء',
      he: 'צג קדמי עם מסך שחור',
      ro: 'Față cu ecran negru',
      nl: 'Voorkant met zwart scherm',
      pl: 'Przód z czarnym ekranem',
      de: 'Vorderseite mit schwarzem Bildschirm',
      es: 'Parte delantera con pantalla en negro',
    },
    FRONT_WHITE: {
      en: 'Front with white screen',
      fr: 'Avant avec écran blanc',
      ar: 'الواجهة الأمامية مع شاشة بيضاء',
      he: 'צג קדמי עם מסך לבן',
      ro: 'Față cu ecran alb',
      nl: 'Voorkant met wit scherm',
      pl: 'Przód z białym ekranem',
      de: 'Vorderseite mit weißem Bildschirm',
      es: 'Parte delantera con pantalla en negro',
    },
    LEFT: {
      en: 'Left side of the device',
      fr: "Côté gauche de l'appareil",
      ar: 'الجهة اليسرى للجهاز',
      he: 'צד שמאל של המכשיר',
      ro: 'Partea stângă a dispozitivului',
      nl: 'Linkerkant van het apparaat',
      pl: 'Lewa strona urządzenia',
      de: 'Linke Seite des Geräts',
      es: 'Lado izquierdo del dispositivo',
    },
    RIGHT: {
      en: 'Right side of the device',
      fr: "Côté droit de l'appareil",
      ar: 'الجهة اليمنى للجهاز',
      he: 'צד ימין של המכשיר',
      ro: 'Partea dreaptă a dispozitivului',
      nl: 'Rechterkant van het apparaat',
      pl: 'Prawa strona urządzenia',
      de: 'Rechte Seite des Geräts',
      es: 'Lado derecho del dispositivo',
    },
    TOP: {
      en: 'Top side',
      fr: 'Côté supérieur',
      ar: 'الجهة العليا',
      he: 'החלק העליון',
      ro: 'Partea de sus',
      nl: 'Bovenkant',
      pl: 'Górna strona',
      de: 'Oberseite',
      es: 'Parte superior',
    },
    BOTTOM: {
      en: 'Bottom side',
      fr: 'Côté inférieur',
      ar: 'الجهة السفلية',
      he: 'החלק התחתון',
      ro: 'Partea de jos',
      nl: 'Onderkant',
      pl: 'Dolna strona',
      de: 'Unterseite',
      es: 'Parte inferior',
    },
  },
  positionsDescription: {
    Back: {
      en: 'Align device, press shutter button, take picture of back of device',
      fr: "Alignez l'appareil, appuyez sur le déclencheur, prenez une photo de l'arrière de l'appareil",
      ar: 'قم بمحاذاة الجهاز ، اضغط على زر الغالق ، التقط صورة لظهر الجهاز',
      he: 'יישר את המכשיר, לחץ על כפתור הצילום, וצלם תמונה של גב המכשיר.',
      ro: 'Aliniați dispozitivul, apăsați butonul declanșator și faceți o fotografie a spatelui dispozitivului.',
      nl: 'Lijn het apparaat uit, druk op de sluiterknop, maak een foto van de achterkant van het apparaat',
      pl: 'Wyrównaj urządzenie, naciśnij przycisk migawki, zrób zdjęcie tyłu urządzenia',
      de: 'Gerät ausrichten, Auslöser drücken, Foto von der Rückseite des Geräts machen',
      es: 'Encuadra el dispositivo y fotografía la parte trasera.',
    },
    Front: {
      en: 'Align device, press shutter, take picture of front screen.',
      fr: "Alignez l'appareil, appuyez sur le déclencheur, prenez une photo de l'écran avant.",
      ar: 'قم بمحاذاة الجهاز ، اضغط على الغالق ، التقط صورة للشاشة الأمامية.',
      he: 'יישר את המכשיר, לחץ על כפתור הצילום וצלם תמונה של המסך הקדמי',
      ro: 'Aliniați dispozitivul, apăsați declanșatorul și faceți o fotografie a ecranului frontal.',
      nl: 'Lijn het apparaat uit, druk op de sluiter, maak een foto van het voorscherm.',
      pl: 'Wyrównaj urządzenie, naciśnij migawkę, zrób zdjęcie ekranu przedniego.',
      de: 'Gerät ausrichten, Auslöser drücken, Foto vom vorderen Bildschirm machen.',
      es: 'Encuadra el dispositivo y fotografía la pantalla.',
    },
    Side: {
      en: 'Please capture the side (with buttons/ports)',
      fr: 'Veuillez capturer le côté (avec boutons/ports)',
      ar: 'يرجى التقاط الجانب (مع الأزرار / المنافذ)',
      he: 'אנא צלם את צד המכשיר (עם הכפתורים/כניסות המכשיר)',
      ro: 'Vă rugăm să capturați partea laterală (cu butoane/porturi).',
      nl: 'Leg de zijkant vast (met knoppen/poorten)',
      pl: 'Proszę uchwycić bok (z przyciskami/portami)',
      de: 'Bitte erfassen Sie die Seite (mit Tasten/Anschlüssen)',
      es: 'Fotografía el lateral (con botones y puertos)',
    },
    FRONT: {
      en: 'Align device, and take picture of the front of device (screen side).',
      fr: "Alignez l'appareil et prenez une photo de l'avant de l'appareil (côté écran).",
      ar: 'قم بتوجيه الجهاز والتقاط صورة للجهة الأمامية للجهاز (جهة الشاشة).',
      he: 'יישר את המכשיר, וצלם את קידמת המכשיר (צד המסך)',
      ro: 'Aliniați dispozitivul și faceți o fotografie a părții frontale (partea ecranului).',
      nl: 'Lijn het apparaat uit en maak een foto van de voorkant van het apparaat (schermzijde).',
      pl: 'Wyrównaj urządzenie i zrób zdjęcie przodu urządzenia (strona ekranu).',
      de: 'Gerät ausrichten und ein Bild von der Vorderseite des Geräts (Bildschirmseite) aufnehmen.',
      es: 'Encuadra el dispositivo y fotografía la parte delantera (pantalla).',
    },
    FRONT_BLACK: {
      en: 'Align the device and capture the front of device (with a black screen).',
      fr: "Alignez l'appareil et capturez l'avant de l'appareil (avec un écran noir).",
      ar: 'محاذاة الجهاز والتقاط صورة للواجهة الأمامية للجهاز (مع شاشة سوداء).',
      he: 'יישר את המכשיר וצלם את קידמת המכשיר (עם מסך שחור)',
      ro: 'Aliniați dispozitivul și capturați partea frontală a dispozitivului (cu ecran negru).',
      nl: 'Lijn het apparaat uit en leg de voorkant van het apparaat vast (met een zwart scherm).',
      pl: 'Wyrównaj urządzenie i uchwyć przód urządzenia (z czarnym ekranem).',
      de: 'Richten Sie das Gerät aus und erfassen Sie die Vorderseite des Geräts (mit schwarzem Bildschirm).',
      es: 'Encuadra el dispositivo y fotografía la parte delantera (con la pantalla en negro).',
    },
    FRONT_WHITE: {
      en: 'Align the device and capture the front of device (with a white screen).',
      fr: "Alignez l'appareil et capturez l'avant de l'appareil (avec un écran blanc).",
      ar: 'محاذاة الجهاز والتقاط صورة للواجهة الأمامية للجهاز (مع شاشة بيضاء).',
      he: 'יישר את המכשיר וצלם את קידמת המכשיר (עם מסך לבן)',
      ro: 'Aliniați dispozitivul și capturați partea frontală a dispozitivului (cu ecran alb).',
      nl: 'Lijn het apparaat uit en leg de voorkant van het apparaat vast (met een wit scherm).',
      pl: 'Wyrównaj urządzenie i uchwyć przód urządzenia (z białym ekranem).',
      de: 'Richten Sie das Gerät aus und erfassen Sie die Vorderseite des Geräts (mit weißem Bildschirm).',
      es: 'Encuadra el dispositivo y fotografía la parte delantera (con la pantalla en blanco).',
    },
    BACK: {
      en: 'Align device, and capture the back of the device (camera side).',
      fr: "Alignez l'appareil et capturez l'arrière de l'appareil (côté caméra).",
      ar: 'قم بتوجيه الجهاز والتقاط صورة للجهة الخلفية للجهاز (جهة الكاميرا).',
      he: 'יישר את המכשיר, וצלם את גב המכשיר (צד המצלמה)',
      ro: 'Aliniați dispozitivul și capturați partea din spate a dispozitivului (partea camerei).',
      nl: 'Lijn het apparaat uit en leg de achterkant van het apparaat vast (camerazijde).',
      pl: 'Wyrównaj urządzenie i uchwyć tył urządzenia (strona aparatu).',
      de: 'Gerät ausrichten und die Rückseite des Geräts (Kameraseite) erfassen.',
      es: 'Encuadra el dispositivo y fotografía la parte trasera (cámara).',
    },
    LEFT: {
      en: 'Make sure the full length of the left side of the device is in the shot.',
      fr: "Assurez-vous que toute la longueur du côté gauche de l'appareil est visible sur la photo.",
      ar: 'تأكد من أن طول الجهة اليسرى للجهاز كاملاً في الصورة.',
      he: 'אנא וודא שכל צד שמאל של המכשיר נכנס בתמונה',
      ro: 'Asigurați-vă că întreaga lungime a părții stângi a dispozitivului este în cadru.',
      nl: 'Zorg ervoor dat de volledige lengte van de linkerkant van het apparaat in beeld is.',
      pl: 'Upewnij się, że cała długość lewej strony urządzenia jest widoczna na zdjęciu.',
      de: 'Stellen Sie sicher, dass die gesamte Länge der linken Seite des Geräts im Bild ist.',
      es: 'Asegúrate de fotografiar todo el lado izquierdo del dispositivo.',
    },
    RIGHT: {
      en: 'Please capture the side (with buttons/ports) are clearly visible.',
      fr: "Veuillez capturer le côté (avec boutons/ports) afin qu'ils soient bien visibles.",
      ar: 'الرجاء التقاط صورة حيث تكون الجهة (مع الأزرار/المنافذ) واضحة بوضوح.',
      he: 'אנא צלם את צד המכשיר (עם הכפתורים/כניסות) וודא שהם ברורים בתמונה',
      ro: 'Vă rugăm să capturați partea laterală (cu butoane/porturi) astfel încât să fie clar vizibilă.',
      nl: 'Leg de zijkant vast (met knoppen/poorten) zodat ze duidelijk zichtbaar zijn.',
      pl: 'Proszę uchwycić bok (z przyciskami/portami), aby były wyraźnie widoczne.',
      de: 'Bitte erfassen Sie die Seite (mit Tasten/Anschlüssen) deutlich sichtbar.',
      es: 'Fotografía el lateral (con botones y puertos claramente visibles).',
    },
    TOP: {
      en: 'Align the device so the full top side is in the shot.',
      fr: "Alignez l'appareil afin que tout le côté supérieur soit visible sur la photo.",
      ar: 'قم بتوجيه الجهاز بحيث يكون الجزء العلوي بأكمله في الصورة.',
      he: 'יישר את המכשיר כך שכל החלק העליון נכנס לתמונה',
      ro: 'Aliniați dispozitivul astfel încât partea superioară completă să fie în cadru.',
      nl: 'Lijn het apparaat uit zodat de volledige bovenkant in beeld is.',
      pl: 'Wyrównaj urządzenie tak, aby cała górna strona była widoczna na zdjęciu.',
      de: 'Richten Sie das Gerät so aus, dass die gesamte Oberseite im Bild ist.',
      es: 'Encuadra el dispositivo y fotografía toda la parte superior.',
    },
    BOTTOM: {
      en: 'Align the base side of the phone with ports in the center.',
      fr: 'Alignez la base du téléphone avec les ports au centre.',
      ar: 'قم بتوجيه الجهاز بحيث تكون الجهة السفلية للهاتف مع المنافذ في المنتصف.',
      he: 'יישר את בסיס המכשיר עם הכניסות באמצע',
      ro: 'Aliniați baza telefonului astfel încât porturile să fie în centru.',
      nl: 'Lijn de basiszijde van de telefoon uit met de poorten in het midden.',
      pl: 'Wyrównaj dolną stronę telefonu z portami w centrum.',
      de: 'Richten Sie die Unterseite des Telefons mit den Anschlüssen in der Mitte aus.',
      es: 'Encuadra la parte inferior del dispositivo con los puertos en el centro.',
    },
  },
  reuploadRequired: {
    title: {
      en: 'Retake this side',
      fr: 'Reprenez cette face',
      ar: 'أعد التقاط هذا الجانب',
      he: 'צלם את צד זה של המכשיר מחדש',
      ro: 'Refă această parte',
      nl: 'Maak deze zijde opnieuw',
      pl: 'Ponownie wykonaj zdjęcie tej strony',
      de: 'Diese Seite erneut aufnehmen',
      es: 'Volver a fotografiar este lado',
    },
    statement: {
      en: 'You have been requested to recapture this image.',
      fr: 'Il vous a été demandé de reprendre cette image.',
      ar: 'لقد طلب منك إعادة التقاط هذه الصورة.',
      he: 'התבקשת לצלם מחדש את התמונה הזו.',
      ro: 'Ți s-a cerut să refaci această imagine.',
      nl: 'Er is u gevraagd deze afbeelding opnieuw vast te leggen.',
      pl: 'Zostałeś poproszony o ponowne wykonanie tego zdjęcia.',
      de: 'Sie wurden gebeten, dieses Bild erneut aufzunehmen.',
      es: 'Vuelve a hacer esta foto.',
    },
  },
  uploadDone: {
    uploadDoneTitle: {
      en: 'Image uploaded',
      fr: 'Image téléchargée',
      ar: 'تم تحميل الصورة بالفعل',
      he: 'תמונה הועלתה בהצלחה',
      ro: 'Imagine încărcată',
      nl: 'Afbeelding geüpload',
      pl: 'Zdjęcie przesłane',
      de: 'Bild hochgeladen',
      es: 'Foto cargada',
    },
  },
  uploadPending: {
    title: {
      en: 'Click to Upload',
      fr: 'Cliquez pour télécharger',
      ar: 'انقر للتحميل',
      he: 'לחץ על מנת להעלות',
      ro: 'Apasă pentru a încărca',
      nl: 'Klik om te uploaden',
      pl: 'Kliknij, aby przesłać',
      de: 'Zum Hochladen klicken',
      es: 'Pulsa para cargar',
    },
  },
  colors: {
    Back_NA_Cropped: {
      en: '',
      ar: '',
      he: '',
      fr: '',
      ro: '',
      nl: '',
      pl: '',
      de: '',
      es: '',
    },
    Back_Black_Cropped: {
      en: 'Black background',
      ar: 'خلفية سوداء',
      he: 'רקע שחור',
      fr: 'Fond noir',
      ro: 'Fundal negru',
      nl: 'Zwarte achtergrond',
      pl: 'Czarne tło',
      de: 'Schwarzer Hintergrund',
      es: 'Fondo negro',
    },
    Back_White_Cropped: {
      en: 'White background',
      ar: 'خلفية بيضاء',
      he: 'רקע לבן',
      fr: 'Fond blanc',
      ro: 'Fundal alb',
      nl: 'Witte achtergrond',
      pl: 'Białe tło',
      de: 'Weißer Hintergrund',
      es: 'Fondo blanco',
    },
    Front_NA_Cropped: {
      en: 'Black or White background',
      ar: 'خلفية سوداء أو بيضاء',
      he: 'רקע לבן או שחור',
      fr: 'Fond noir ou blanc',
      ro: 'Fundal negru sau alb',
      nl: 'Zwarte of witte achtergrond',
      pl: 'Czarne lub białe tło',
      de: 'Schwarzer oder weißer Hintergrund',
      es: 'Fondo negro o blanco',
    },
    Front_Black_Cropped: {
      en: 'Black background',
      ar: 'خلفية سوداء',
      he: 'רקע שחור',
      fr: 'Fond noir',
      ro: 'Fundal negru',
      nl: 'Zwarte achtergrond',
      pl: 'Czarne tło',
      de: 'Schwarzer Hintergrund',
      es: 'Fondo negro',
    },
    Front_White_Cropped: {
      en: 'White background',
      ar: 'خلفية بيضاء',
      he: 'רקע לבן',
      fr: 'Fond blanc',
      ro: 'Fundal alb',
      nl: 'Witte achtergrond',
      pl: 'Białe tło',
      de: 'Weißer Hintergrund',
      es: 'Fondo blanco',
    },
    Side_NA_Cropped: {
      en: 'Black or White background',
      ar: 'خلفية سوداء أو بيضاء',
      he: 'או רקע לבן או רקע שחור',
      fr: 'Fond noir ou blanc',
      ro: 'Fundal negru sau alb',
      nl: 'Zwarte of witte achtergrond',
      pl: 'Czarne lub białe tło',
      de: 'Schwarzer oder weißer Hintergrund',
      es: 'Fondo negro o blanco',
    },
    Side_Black_Cropped: {
      en: 'Black background',
      ar: 'خلفية سوداء',
      he: 'רקע שחור',
      fr: 'Fond noir',
      ro: 'Fundal negru',
      nl: 'Zwarte achtergrond',
      pl: 'Czarne tło',
      de: 'Schwarzer Hintergrund',
      es: 'Fondo negro',
    },
    Side_White_Cropped: {
      en: 'White background',
      ar: 'خلفية بيضاء',
      he: 'רקע לבן',
      fr: 'Fond blanc',
      ro: 'Fundal alb',
      nl: 'Witte achtergrond',
      pl: 'Białe tło',
      de: 'Weißer Hintergrund',
      es: 'Fondo blanco',
    },
    ANY: {
      en: '',
      ar: '',
      he: ' ',
      fr: '',
      ro: '',
      nl: '',
      pl: '',
      de: '',
      es: '',
    },
  },
  colorsDescription: {
    Back_NA_Cropped: {
      en: 'Either a black or white background.',
      ar: 'أي خلفية أسود / أبيض',
      he: 'או רקע לבן או רקע שחור',
      fr: 'Soit un fond noir, soit un fond blanc.',
      ro: 'Fie un fundal negru, fie un fundal alb.',
      nl: 'Of een zwarte of witte achtergrond.',
      pl: 'Albo czarne, albo białe tło.',
      de: 'Entweder ein schwarzer oder weißer Hintergrund.',
      es: 'El fondo puede ser negro o blanco.',
    },
    Back_Black_Cropped: {
      en: "Make sure it's against a black background.",
      ar: 'خلفية سوداء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע שחור',
      fr: "Assurez-vous qu'il soit contre un fond noir.",
      ro: 'Asigurați-vă că este pe un fundal negru.',
      nl: 'Zorg ervoor dat het tegen een zwarte achtergrond is.',
      pl: 'Upewnij się, że jest na czarnym tle.',
      de: 'Stellen Sie sicher, dass es auf einem schwarzen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es negro.',
    },
    Back_White_Cropped: {
      en: "Make sure it's against a white background.",
      ar: 'خلفية بيضاء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע לבן',
      fr: "Assurez-vous qu'il soit contre un fond blanc.",
      ro: 'Asigurați-vă că este pe un fundal alb.',
      nl: 'Zorg ervoor dat het tegen een witte achtergrond is.',
      pl: 'Upewnij się, że jest na białym tle.',
      de: 'Stellen Sie sicher, dass es auf einem weißen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es blanco.',
    },
    Front_NA_Cropped: {
      en: 'Either a black or white background.',
      ar: 'أي خلفية أسود / أبيض',
      he: 'או מסך לבן או מסך שחור',
      fr: 'Soit un fond noir, soit un fond blanc.',
      ro: 'Fie un fundal negru, fie un fundal alb.',
      nl: 'Of een zwarte of witte achtergrond.',
      pl: 'Albo czarne, albo białe tło.',
      de: 'Entweder ein schwarzer oder weißer Hintergrund.',
      es: 'El fondo puede ser negro o blanco.',
    },
    Front_Black_Cropped: {
      en: "Make sure it's against a black background.",
      ar: 'خلفية سوداء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע שחור',
      fr: "Assurez-vous qu'il soit contre un fond noir.",
      ro: 'Asigurați-vă că este pe un fundal negru.',
      nl: 'Zorg ervoor dat het tegen een zwarte achtergrond is.',
      pl: 'Upewnij się, że jest na czarnym tle.',
      de: 'Stellen Sie sicher, dass es auf einem schwarzen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es negro.',
    },
    Front_White_Cropped: {
      en: "Make sure it's against a white background.",
      ar: 'خلفية بيضاء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע לבן',
      fr: "Assurez-vous qu'il soit contre un fond blanc.",
      ro: 'Asigurați-vă că este pe un fundal alb.',
      nl: 'Zorg ervoor dat het tegen een witte achtergrond is.',
      pl: 'Upewnij się, że jest na białym tle.',
      de: 'Stellen Sie sicher, dass es auf einem weißen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es blanco.',
    },
    Side_NA_Cropped: {
      en: 'Either a black or white background.',
      ar: 'أي خلفية أسود / أبيض',
      he: 'או רקע לבן או רקע שחור',
      fr: 'Soit un fond noir, soit un fond blanc.',
      ro: 'Fie un fundal negru, fie un fundal alb.',
      nl: 'Of een zwarte of witte achtergrond.',
      pl: 'Albo czarne, albo białe tło.',
      de: 'Entweder ein schwarzer oder weißer Hintergrund.',
      es: 'El fondo puede ser negro o blanco.',
    },
    Side_Black_Cropped: {
      en: "Make sure it's against a black background.",
      ar: 'خلفية سوداء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע שחור',
      fr: "Assurez-vous qu'il soit contre un fond noir.",
      ro: 'Asigurați-vă că este pe un fundal negru.',
      nl: 'Zorg ervoor dat het tegen een zwarte achtergrond is.',
      pl: 'Upewnij się, że jest na czarnym tle.',
      de: 'Stellen Sie sicher, dass es auf einem schwarzen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es negro.',
    },
    Side_White_Cropped: {
      en: "Make sure it's against a white background.",
      ar: 'خلفية بيضاء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע לבן',
      fr: "Assurez-vous qu'il soit contre un fond blanc.",
      ro: 'Asigurați-vă că este pe un fundal alb.',
      nl: 'Zorg ervoor dat het tegen een witte achtergrond is.',
      pl: 'Upewnij się, że jest na białym tle.',
      de: 'Stellen Sie sicher, dass es auf einem weißen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es blanco.',
    },
    ANY: {
      en: "Make sure it's against a white background.",
      ar: 'خلفية بيضاء',
      he: 'שימו לב שהמכשיר מונח כנגד רקע לבן',
      fr: "Assurez-vous qu'il soit contre un fond blanc.",
      ro: 'Asigurați-vă că este pe un fundal alb.',
      nl: 'Zorg ervoor dat het tegen een witte achtergrond is.',
      pl: 'Upewnij się, że jest na białym tle.',
      de: 'Stellen Sie sicher, dass es auf einem weißen Hintergrund ist.',
      es: 'Asegúrate de que el fondo es blanco.',
    },
  },
};
